import { GlobeHemisphereWest, Key, Handshake } from "@phosphor-icons/react";
import { Reveal, SectionHead } from "./Reveal";
import { IMAGES } from "@/data/content";
import { useLanguage } from "@/i18n";

const CHAPTER_ICONS = [GlobeHemisphereWest, Key, Handshake];

export default function About() {
  const { t } = useLanguage();
  return (
    <section id="about" data-testid="about-section" className="mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-36">
      <SectionHead index={t.about.index} overline={t.about.overline} title={t.about.title} testid="about" />
      <div className="mt-16 grid gap-16 lg:grid-cols-2 lg:gap-20">
        <Reveal delay={0.1}>
          <p className="font-serif text-2xl leading-relaxed text-[#E5C07B] md:text-3xl">{t.about.quote}</p>
          <p className="mt-8 leading-relaxed text-[#A3A3A3] md:text-lg">{t.about.p1}</p>
          <p className="mt-6 leading-relaxed text-[#A3A3A3] md:text-lg">{t.about.p2}</p>
        </Reveal>
        <Reveal delay={0.2} className="relative">
          <div className="relative overflow-hidden border border-gold/20">
            <img src={IMAGES.gold} alt="Charbel Moubarak portrait" data-testid="about-portrait" className="h-[520px] w-full object-cover object-[50%_44%] transition-transform duration-700 hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-charcoal/80 via-transparent to-transparent" />
            <p className="absolute bottom-4 left-4 text-[10px] uppercase tracking-[0.3em] text-gold/80">{t.about.badge}</p>
          </div>
          <div className="absolute -right-3 -top-3 -z-10 h-full w-full border border-gold/30" />
        </Reveal>
      </div>
      <div className="mt-20 grid gap-8 md:grid-cols-3">
        {t.about.chapters.map((c, i) => {
          const Icon = CHAPTER_ICONS[i];
          return (
            <Reveal key={c.num} delay={i * 0.12} className="group border border-gold/15 bg-surface p-8 transition-all duration-500 hover:-translate-y-2 hover:border-gold/50 hover:shadow-lg hover:shadow-gold/5">
              <div className="flex items-baseline justify-between">
                <span className="font-serif text-5xl text-gold/25 transition-colors duration-500 group-hover:text-gold/60">{c.num}</span>
                <Icon size={28} weight="duotone" className="text-gold" />
              </div>
              <h3 className="mt-6 font-serif text-xl tracking-wider text-gold md:text-2xl">{c.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-[#A3A3A3]">{c.text}</p>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
}
